const gameStore = {
  GAMES: '/game-store/games',
  PROVIDERS: '/game-store/providers',
  EDIT: '/game-store/games/edit',
}

export default gameStore
